import { useEffect, useContext } from 'react'
import { useDispatch } from 'react-redux'
import {
	SIgnalRNotificationEventType,
	NotificationMessage,
} from '../model/signalRNotifications'
import { useEvent } from './useEvent'
import { SignalRContext } from '../providers/SignalRProvider'
import { notificationsService } from '../utils/signalRNotifications/notifications-service'
import displayContentActions from '../features/displayContent/actions'
import { DisplayableContent } from '../model/model'
import { transformToDisplayableContent } from '../utils/transformModel'

// Custom hook to handle notification events
// this file will replace - functionality wise - the useSocket file
const useNotificationGroup = (groupName?: string) => {
	const { connectionId } = useContext(SignalRContext)

	useEffect(() => {
		if (!groupName || !connectionId) {
			return
		}
		notificationsService.addConnectionToGroup(groupName)

		return () => {
			notificationsService.removeConnectionFromGroup(groupName)
		}
	}, [groupName, connectionId])
}

export const useNotificationShare = (examId?: string) => {
	const dispatch = useDispatch()
	const { subscribe } = useEvent()

	const groupName = examId ? `exam:${examId}` : undefined
	useNotificationGroup(groupName)

	useEffect(() => {
		if (!groupName) return

		// the equivalent socket events are defined in roomSocket.ts; but we'll define the new (SignalR) ones directly in here for clarity
		subscribe(
			SIgnalRNotificationEventType.ShareStarted,
			(event: NotificationMessage) => {
				if (event.type !== SIgnalRNotificationEventType.ShareStarted) {
					return
				}

				const { section, content } = event.data
				const transformedData = transformToDisplayableContent(section, content)
				const shareData: DisplayableContent = event.data

				dispatch(
					displayContentActions.setDisplayContent({
						type: shareData.section,
						data: transformedData,
					}),
				)

				dispatch(displayContentActions.setPlaying({ playing: true }))
			},
			{ self: true },
		)

		subscribe(
			SIgnalRNotificationEventType.ShareEnded,
			() => {
				dispatch(displayContentActions.clearDisplayContent())
			},
			{ self: true },
		)

	}, [groupName, dispatch, subscribe])
}
